import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const SpendByUserChart = ({ transactions }) => {
  // Group transactions by user
  const groupedData = transactions.reduce((acc, txn) => {
    const userId = txn.userId || txn.user?.id;
    const userName = txn.user
      ? `${txn.user.firstName || ''} ${txn.user.lastName || ''}`.trim()
      : 'Unknown User';

    if (!acc[userId]) {
      acc[userId] = {
        userId,
        userName,
        totalSpend: 0,
        transactionCount: 0
      };
    }

    acc[userId].totalSpend += parseFloat(txn.amount || 0);
    acc[userId].transactionCount += 1;

    return acc;
  }, {});

  // Convert to array, sort by total spend, and take top 10
  const chartData = Object.values(groupedData)
    .sort((a, b) => b.totalSpend - a.totalSpend)
    .slice(0, 10);

  const formatCurrency = (value) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-3">
          <p className="text-sm font-semibold text-gray-900">
            {payload[0].payload.userName}
          </p>
          <p className="text-sm text-gray-700 mt-1">
            Total Spend: <span className="font-semibold">{formatCurrency(payload[0].value)}</span>
          </p>
          <p className="text-sm text-gray-600">
            Transactions: {payload[0].payload.transactionCount}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Spend by Employee (Top 10)</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart
          data={chartData}
          layout="horizontal"
          margin={{ top: 5, right: 30, left: 100, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis
            type="number"
            tickFormatter={formatCurrency}
            tick={{ fontSize: 12, fill: '#6b7280' }}
            stroke="#9ca3af"
          />
          <YAxis
            type="category"
            dataKey="userName"
            tick={{ fontSize: 12, fill: '#6b7280' }}
            stroke="#9ca3af"
            width={90}
          />
          <Tooltip content={<CustomTooltip />} />
          <Bar
            dataKey="totalSpend"
            fill="#10b981"
            name="Total Spend"
            radius={[0, 4, 4, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default SpendByUserChart;
